export const AwakenedWhitelistAddress = '0x5BaFEe6f3Eb5b687E53e33355602652d98a562Dc';
export const AwakenedMintPassAddress = '0x31EabB6ea6bE8D95DC1865135D1822aF4FF1E177';
export const TreasuryAddress = '0x2337b0B6992C80d22449B460E7920E770a68d618';
export const AwakenedChampionAddress = '0x5210475c630F77D8f0E901F94197387c767A9611';
